export function currencyParse(value: string): number {
  const amountString = value.replace(/[^0-9.]/g, '');
  return Number(amountString);
}

export function currencyStringCreate(value: string): string {
  const v = value.replace(/\D/g, '').slice();
  const t = v !== '' ? parseInt(v, 10).toString() : '0';
  let formatted = '';
  switch (t.length) {
    case 0:
      return '$0.00';
    case 1:
      return `$0.0${t}`;
    case 2:
      return `$0.${t}`;
    default:
      formatted = t.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return `$${formatted}.${t.slice(-2)}`;
  }
}

